import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
const StatsAndTestimonials = lazy(() => import('./components/StatsAndTestimonials').then(m => ({
  default: m.StatsAndTestimonials
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Modules = lazy(() => import('./components/Modules').then(m => ({
  default: m.Modules
})));
const PlanillasPreview = lazy(() => import('./components/PlanillasPreview').then(m => ({
  default: m.PlanillasPreview
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const IsForYou = lazy(() => import('./components/IsForYou').then(m => ({
  default: m.IsForYou
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseToast = lazy(() => import('./components/PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
export function App() {
  const [showBelowFold, setShowBelowFold] = useState(false);
  const [showPurchaseToast, setShowPurchaseToast] = useState(false);
  useEffect(() => {
    // Defer mounting below-the-fold sections until the browser is idle
    // → keeps initial paint blazing fast and only pays the cost when needed.
    const ric: any = (window as any).requestIdleCallback || ((cb: any) => setTimeout(cb, 1));
    const cic: any = (window as any).cancelIdleCallback || ((id: any) => clearTimeout(id));
    let triggered = false;
    const reveal = () => {
      if (triggered) return;
      triggered = true;
      setShowBelowFold(true);
    };
    // Reveal on any user interaction OR after idle, whichever first
    const onInteract = () => reveal();
    window.addEventListener('scroll', onInteract, {
      once: true,
      passive: true
    });
    window.addEventListener('pointerdown', onInteract, {
      once: true,
      passive: true
    });
    window.addEventListener('keydown', onInteract, {
      once: true,
      passive: true
    });
    const idleReveal = ric(reveal, {
      timeout: 1200
    });
    // Prefetch waves
    const prefetch = ric(() => {
      import('./components/StatsAndTestimonials');
      import('./components/PainPoints');
      import('./components/Modules');
      setTimeout(() => {
        import('./components/PlanillasPreview');
        import('./components/Bonuses');
        import('./components/IsForYou');
      }, 400);
      setTimeout(() => {
        import('./components/Pricing');
        import('./components/CostComparison');
        import('./components/FinalCTA');
      }, 900);
      setTimeout(() => {
        import('./components/Footer');
        import('./components/PurchaseToast');
      }, 1600);
    }, {
      timeout: 800
    });
    // Fire InitiateCheckout when a purchase link is clicked
    // (Pixel itself is initialized synchronously in index.tsx)
    const onCheckoutClick = (e: Event) => {
      const target = e.target as HTMLElement | null;
      const anchor = target?.closest?.('a[href*="fegion.shop/cart"]') as HTMLAnchorElement | null;
      if (!anchor) return;
      const fbq = (window as any).fbq;
      if (typeof fbq !== 'function') return;
      const isPro = anchor.href.includes('47115293393035');
      fbq('track', 'InitiateCheckout', {
        content_name: isPro ? 'Sistema Maestro + Pack de Aceleración' : 'Sistema Maestro Completo',
        content_ids: [isPro ? '47115293393035' : '47115288019083'],
        value: isPro ? 29990 : 19990,
        currency: 'ARS'
      });
    };
    document.addEventListener('click', onCheckoutClick, {
      capture: true
    });
    // Toast: load only after meaningful user engagement
    const mountToast = () => {
      setShowPurchaseToast(true);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
    window.addEventListener('scroll', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('pointerdown', mountToast, {
      once: true,
      passive: true
    });
    window.addEventListener('keydown', mountToast, {
      once: true,
      passive: true
    });
    return () => {
      cic(idleReveal);
      cic(prefetch);
      document.removeEventListener('click', onCheckoutClick, {
        capture: true
      } as any);
      window.removeEventListener('scroll', onInteract);
      window.removeEventListener('pointerdown', onInteract);
      window.removeEventListener('keydown', onInteract);
      window.removeEventListener('scroll', mountToast);
      window.removeEventListener('pointerdown', mountToast);
      window.removeEventListener('keydown', mountToast);
    };
  }, []);
  return <div className="min-h-screen text-gray-200 font-body selection:bg-gold selection:text-bg antialiased" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-gold focus:text-bg focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>
      <main id="main-content" data-id="element-2">
        <Hero data-id="element-3" />
        {showBelowFold && <div className="lazy-sections" data-id="element-4">
            <Suspense fallback={null} data-id="element-5">
              <StatsAndTestimonials data-id="element-6" />
              <PainPoints data-id="element-7" />
              <Modules data-id="element-8" />
              <PlanillasPreview data-id="element-9" />
              <Bonuses data-id="element-10" />
              <IsForYou data-id="element-11" />
              <Pricing data-id="element-12" />
              <CostComparison data-id="element-13" />
              <FinalCTA data-id="element-14" />
            </Suspense>
          </div>}
      </main>
      {showBelowFold && <Suspense fallback={null} data-id="element-15">
          <Footer data-id="element-16" />
          {showPurchaseToast && <PurchaseToast data-id="element-17" />}
        </Suspense>}
    </div>;
}